export default "__VITE_ASSET__CnYI4gg4__"